import { useTranslation } from 'react-i18next'

import { PackageIcon } from '@phosphor-icons/react'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

const PrepareParcelButton = ({
  shippingSkipPacking,
  onAutoPrepareParcel,
  onPrepareParcel,
  preparingParcel,
  allowPrepareParcel,
}) => {
  const { t } = useTranslation()

  if (!allowPrepareParcel) return null

  return (
    <ButtonWithSpinner
      variant="text"
      onClick={shippingSkipPacking ? onAutoPrepareParcel : onPrepareParcel}
      defaultLabel={
        <>
          <PackageIcon />
          {t('Preparar envío')}
        </>
      }
      loadingLabel={
        <>
          <PackageIcon />
          {t('Preparar envío')}
        </>
      }
      disabled={preparingParcel}
      loading={preparingParcel}
    />
  )
}

export default PrepareParcelButton
